import React, { Fragment, useState, useEffect, useRef } from 'react'
import { Button, Card, Col, CardBody, Input, Row, Media } from 'reactstrap'
import { TableStriped } from '../../../components/tables/TableStriped'
import { ModalUser } from '../../../components/users/ModalUser'
import { ModalCard } from '../../../components/users/ModalCard'
import { useUser } from '../../../hooks/usersRols/useUser'
import { ModalViewSection } from './ModalViewSection'
import { Search, Edit, Globe, BookOpen, FileText, Youtube, MessageCircle, Mail, RotateCcw, DollarSign, Check, Link, Codepen, HelpCircle, Aperture, Settings, MessageSquare } from 'react-feather';
import { ViewSections } from './ViewSections'
import { ModalCedula } from './ModalCedula'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { SelectButton } from 'primereact/selectbutton';





export const ComponentUser = ({ activeTab }) => {
    const {
        modalTitle, modalUser, methodUser, toggleUser, typeCard, checkbox, check,
        handleCheckboxChange, section, changeTree, treeviewRef, tree, onRenderItem,
        saveCardCode, handleListSectionsCard, card_code, checkSection, handleCheckChange,
        listDepartament,
        //USERS MODEL
        listUsers, listRol, loading, name_user, listRoles, handleInputChange,
        handleSelectValues, validationsUser, handleInputChangeT, id_departament,
        departament,
        //USERS METHODS
        handleUpdate, saveUpdatePatient, totalPageCount, currentPage, handleListCard,
        nextPage, previousPage, goToPage, handleSearchUser, handleListSection,
        modalTitleSection, modalSection, toggleSection, typeModal, selected,
        onChange, data, imagen, saveUpdateSections, listSection, listSect,
        modalTitleSection2, modalSection2, typeModalSection, handleListSections,
        toggleSection2, dataSections, sectionSelected, handleCard, handleSectionUser,
        //card
        modalCard, toggleCard, modalTitleCard, processes, formUser, id_departaments,
        listDepa, handleListCedula, modalCedula, toggleCedula, typeCedula, professional_license, userId, saveProfessionalLicense,
        formValuesC, handleInputChangeC, url_helen, exportExcel,
        permissions, togglePermission,
        handleConfiguration,
        modalConfiguration, toggleConfiguration, permissionOptions,
        isAdminLoggedUser, saveConfiguration, loadingConfiguration


    } = useUser();
    console.log("🚀 ~ ComponentUser ~ name_user:", name_user)









    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };
    const btnStyle = (bgColor = "#007bff") => ({
        padding: "2px",
        fontSize: "1rem",
        height: "26px",
        width: "26px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: bgColor,
        color: "#fff"
    });



    const actions = (rowData) => {

        return (
            <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: "3px", marginRight: "3px" }}
            >

                {/* Botón Sección */}
                <button
                    onClick={() => handleListSection(rowData.id_user)}
                    disabled={loading}
                    style={btnStyle("#016392")}
                    className="btn btn-outline btn-sm"
                    title='Secciones y areas asignadas'
                >
                    <i className="icofont icofont-prescription"></i>
                </button>

                {/* Botón Tarjeta */}
                <button
                    onClick={() => handleListCard(rowData.id_user)}
                    disabled={loading}
                    style={btnStyle("#b32b5d")}
                    className="btn btn-outline btn-sm"
                    title='Accesos'
                >
                    <i className="icofont icofont-credit-card"></i>
                </button>

                {/* Botón Cédula */}
                <button
                    onClick={() => handleListCedula(rowData.id_user)}
                    disabled={loading}
                    style={btnStyle("#ffe047")}
                    className="btn btn-outline btn-sm"
                    title='Cedula profesional'
                >
                    <i className="icofont icofont-ui-v-card"></i>
                </button>

                {/* Botón Editar */}
                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_user)}
                    disabled={loading}
                    style={btnStyle()}
                    title='Asignar Roles'
                >
                    <i className="fa fa-edit"></i>
                </Button>

                {isAdminLoggedUser && (
                    <Button
                        title='Configuración'
                        size="sm"
                        onClick={() => handleConfiguration(rowData.id_user)}
                        disabled={loading}
                        style={btnStyle("#28a745")}
                    >
                        <i className="pi pi-id-card"></i>
                    </Button>
                )}

            </div>
        );
    };



    const header = (
        <div className="d-flex align-items-center justify-content-between w-100" style={{ gap: '1rem', marginBottom: '1rem' }}>
            <Button
                color="success"
                onClick={exportExcel}
                size="sm"
                title="Exportar a Excel"
                style={{
                    padding: "2px 6px",
                    height: "28px",
                    fontSize: "0.8rem",
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <i className="pi pi-file-excel me-1" />
            </Button>

            <Input
                placeholder='Busqueda...'
                className='form-control form-control-sm'
                onChange={handleSearchUser}
                style={{ maxWidth: '450px', width: '100%' }}
            />
        </div>
    );





    return (
        <>
            <Card>
                <CardBody className='p-1'>

                    <Row className='m-t-2'>
                        <Col sm="12" md="12" lg="12">
                            <div className='table-responsive'>

                                <DataTable
                                    value={listUsers}
                                    paginator
                                    rows={10}
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "20%" }} alt="Sin Usuarios" />
                                            <br />
                                            <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                Sin Usuarios.
                                            </p>
                                        </div>
                                    }
                                    rowsPerPageOptions={[10, 50, 100]}
                                    responsiveLayout="scroll"
                                    header={header}
                                    loading={loading}
                                >
                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                    <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle} />
                                    <Column field="id_external" header="Usuario" sortable headerStyle={headerStyle} style={cellStyle} />
                                    <Column
                                        field="array_roles"
                                        header="Roles"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => {
                                            return (
                                                <ul style={{ paddingLeft: "20px" }}>
                                                    {rowData.array_roles.map((role, index) => (
                                                        <li key={index}>{role}</li>
                                                    ))}
                                                </ul>
                                            );
                                        }}
                                    />
                                    <Column
                                        field="professional_license"
                                        header="Cédula Profesional"
                                        sortable
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                        body={(rowData) => {
                                            return rowData.professional_license ? rowData.professional_license : "Sin Cédula Profesional";
                                        }}
                                    />
                                    <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />
                                </DataTable>


                            </div>
                            <br /> <br />
                        </Col>



                    </Row>
                </CardBody>
            </Card>
            <ModalCard
                {
                ...{
                    modalCard, modalTitleCard, toggleCard, loading, handleListCard,
                    typeCard, checkbox, check, handleCheckboxChange, handleInputChangeT, id_departament,
                    departament, handleSectionUser, section, changeTree, treeviewRef, tree,
                    onRenderItem, processes, saveCardCode, handleListSectionsCard,
                    card_code, handleInputChange, checkSection, handleCheckChange, listDepartament,
                    handleSelectValues, formUser, id_departaments, listDepa, url_helen, name_user
                }
                }
            />
            <ModalUser
                {
                ...{
                    modal: modalUser, modalTitle, toggle: toggleUser, method: methodUser, loading,
                    listRol, name: name_user, listRoles,
                    handleInputChange, handleSelectValues,
                    saveUpdatePatient, validaciones: validationsUser
                }
                }
            />
            <ModalViewSection
                {
                ...{
                    modalTitleSection, modalSection, loading, toggleSection, typeModal, selected, onChange, data, saveUpdateSections,
                    listSection, listSect, handleSelectValues, sectionSelected, name_user
                }
                }
            />
            <ViewSections
                {
                ...{ modalTitleSection2, modalSection2, typeModalSection, handleListSections, toggleSection2, loading, dataSections, name_user }
                }
            />

            <ModalCedula
                {...{
                    modalCedula, toggleCedula, modalTitleCard, typeCedula, handleInputChange, professional_license, userId, saveProfessionalLicense,
                    handleInputChangeC, formValuesC, name_user

                }}
            />
            {
                // * MODAL CONFIGURATION
            }
            <Dialog
                visible={modalConfiguration}
                onHide={toggleConfiguration}
                header={"Permisos"}
                headerStyle={{
                    backgroundColor: '#0d3b59',
                    color: 'white',
                    fontWeight: 'bold'
                }}
                pt={{
                    header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                    headerIcon: { style: { color: 'white' } },
                }}
                className="dialog-authorized"
                footer={
                    <>
                        <Button
                            size="sm"
                            type="button"
                            color="danger"
                            className="btn-air-light"
                            onClick={toggleConfiguration}
                        >
                            {"Cancelar" ?? "---"}
                        </Button>
                        <Button
                            size="sm"
                            color="secondary"
                            type="button"
                            onClick={() => saveConfiguration()}
                        >
                            {loadingConfiguration ? "Cargando..." : "Actualizar" ?? "Actualizar"}
                        </Button>
                    </>
                }
            >
                <Col sm="12" className='pl-0 pr-0'  >
                    <div className="user-header mb-3">
                        <div className="d-flex align-items-center user-header-content">
                            <div className="user-avatar">
                                {name_user?.charAt(0)}
                            </div>

                            <div className="user-info">
                                <div className="user-name">
                                    {name_user}
                                </div>
                                <div className="user-subtitle">
                                    Configuración de permisos
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="permission-grid">
                        {permissions.map((item, index) => (
                            <div key={index} className="permission-card">

                                <div className="d-flex align-items-center justify-content-between">

                                    <div className="d-flex align-items-center">
                                        <div className="permission-icon">
                                            <i className={item.icon}></i>
                                        </div>

                                        <div>
                                            <div className="permission-title">
                                                {item.label}
                                            </div>
                                            <div className="permission-desc">
                                                {item.description}
                                            </div>
                                        </div>
                                    </div>

                                    <SelectButton
                                        value={item.enabled}
                                        options={permissionOptions}
                                        onChange={(e) => togglePermission(item.key, e.value)}
                                        className={`permission-toggle-sm permission-${item.key}`}
                                        unselectable={false}
                                    />
                                </div>

                            </div>
                        ))}
                    </div>


                </Col>


            </Dialog>




        </>
    )
}
